import { TIME_WINDOWS_MAP } from "@utils/constants";
import type { TimeUnitConfig } from "./TimeWindowPresetOption.types";

export const TIME_UNIT_CONFIG: TimeUnitConfig[] = [
  {
    check: (years) => years > 0,
    increment: TIME_WINDOWS_MAP.YEAR,
    minimum: TIME_WINDOWS_MAP.YEAR,
  },
  {
    check: (years, months = 0) => months > 0 && months <= 12 && years === 0,
    increment: TIME_WINDOWS_MAP.MONTH,
    minimum: TIME_WINDOWS_MAP.MONTH,
    maximum: TIME_WINDOWS_MAP.MONTH * 11.5,
  },
  {
    check: (years, months = 0, days = 0) =>
      days > 0 && days < 28 && months === 0 && years === 0,
    increment: TIME_WINDOWS_MAP.DAY,
    minimum: TIME_WINDOWS_MAP.DAY,
    maximum: TIME_WINDOWS_MAP.DAY * 28,
  },
  {
    check: (years, months = 0, days = 0, hours = 0) =>
      days < 1 && hours <= 24 && months === 0 && years === 0,
    increment: TIME_WINDOWS_MAP.HOUR,
    minimum: TIME_WINDOWS_MAP.HOUR,
    maximum: TIME_WINDOWS_MAP.HOUR * 23,
  },
];
